import * as React from "react";

import { createSvgIcon } from "@mui/material/utils";

const Achievement3Icon = createSvgIcon(
    <svg
        width="160"
        height="160"
        viewBox="0 0 160 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="80" cy="80" r="80" fill="url(#paint0_linear_5305_1573)" />
        <g filter="url(#filter0_i_5305_1573)">
            <circle
                cx="80"
                cy="80"
                r="67"
                fill="url(#paint1_linear_5305_1573)"
            />
        </g>
        <circle cx="80" cy="80" r="67" stroke="#842F10" strokeWidth="3" />
        <g filter="url(#filter1_d_5305_1573)">
            <path
                d="M53.2065 75.634C53.9402 74.1475 56.0598 74.1475 56.7935 75.634L61.882 85.9444C62.1733 86.5347 62.7364 86.9438 63.3879 87.0385L74.7661 88.6918C76.4065 88.9302 77.0615 90.9462 75.8745 92.1032L67.6411 100.129C67.1698 100.588 66.9547 101.25 67.066 101.899L69.0096 113.231C69.2898 114.865 67.5749 116.111 66.1077 115.34L55.9307 109.989C55.348 109.683 54.652 109.683 54.0693 109.989L43.8923 115.34C42.4251 116.111 40.7102 114.865 40.9904 113.231L42.934 101.899C43.0453 101.25 42.8302 100.588 42.3589 100.129L34.1255 92.1032C32.9385 90.9462 33.5935 88.9302 35.2339 88.6918L46.6122 87.0385C47.2636 86.9438 47.8267 86.5347 48.118 85.9444L53.2065 75.634Z"
                fill="#F29441"
            />
            <path
                d="M53.8789 75.9658C54.3088 75.0948 55.5004 75.0404 56.0254 75.8027L56.1211 75.9658L61.209 86.2764C61.5845 87.0372 62.2888 87.5789 63.1133 87.751L63.2803 87.7803L74.6582 89.4336C75.6195 89.5733 76.0393 90.69 75.4766 91.4248L75.3506 91.5664L67.1172 99.5918C66.5097 100.184 66.2125 101.021 66.3037 101.858L66.3271 102.025L68.2705 113.358C68.4344 114.316 67.5025 115.06 66.6299 114.752L66.457 114.676L56.2793 109.325C55.5283 108.931 54.6401 108.906 53.8721 109.251L53.7207 109.325L43.543 114.676C42.6834 115.127 41.688 114.472 41.7109 113.547L41.7295 113.358L43.6729 102.025C43.8162 101.189 43.566 100.337 43 99.7129L42.8828 99.5918L34.6494 91.5664C33.9538 90.8884 34.2699 89.7383 35.1572 89.4746L35.3418 89.4336L46.7197 87.7803C47.5593 87.6583 48.2925 87.1567 48.7109 86.4258L48.791 86.2764L53.8789 75.9658Z"
                stroke="#842F10"
                strokeWidth="1.5"
            />
        </g>
        <g filter="url(#filter2_d_5305_1573)">
            <path
                d="M78.2065 33.634C78.9402 32.1475 81.0598 32.1475 81.7935 33.634L86.882 43.9444C87.1733 44.5347 87.7364 44.9438 88.3879 45.0385L99.7661 46.6918C101.407 46.9302 102.062 48.9462 100.875 50.1032L92.6411 58.1288C92.1698 58.5883 91.9547 59.2503 92.066 59.899L94.0096 71.2313C94.2898 72.8651 92.5749 74.111 91.1077 73.3397L80.9307 67.9893C80.348 67.683 79.652 67.683 79.0693 67.9893L68.8923 73.3397C67.4251 74.111 65.7102 72.8651 65.9904 71.2313L67.934 59.899C68.0453 59.2503 67.8302 58.5883 67.3589 58.1288L59.1255 50.1032C57.9385 48.9462 58.5935 46.9302 60.2339 46.6918L71.6122 45.0385C72.2636 44.9438 72.8267 44.5347 73.118 43.9444L78.2065 33.634Z"
                fill="#F29441"
            />
            <path
                d="M78.8789 33.9658C79.3088 33.0948 80.5004 33.0404 81.0254 33.8027L81.1211 33.9658L86.209 44.2764C86.5845 45.0372 87.2888 45.5789 88.1133 45.751L88.2803 45.7803L99.6582 47.4336C100.619 47.5733 101.039 48.69 100.477 49.4248L100.351 49.5664L92.1172 57.5918C91.5097 58.1841 91.2125 59.0211 91.3037 59.8584L91.3271 60.0254L93.2705 71.3584C93.4344 72.3156 92.5025 73.06 91.6299 72.752L91.457 72.6758L81.2793 67.3252C80.5283 66.9305 79.6401 66.9055 78.8721 67.251L78.7207 67.3252L68.543 72.6758C67.6834 73.1274 66.688 72.4717 66.7109 71.5469L66.7295 71.3584L68.6729 60.0254C68.8162 59.1891 68.566 58.3367 68 57.7129L67.8828 57.5918L59.6494 49.5664C58.9538 48.8884 59.2699 47.7383 60.1572 47.4746L60.3418 47.4336L71.7197 45.7803C72.5593 45.6583 73.2925 45.1567 73.7109 44.4258L73.791 44.2764L78.8789 33.9658Z"
                stroke="#842F10"
                strokeWidth="1.5"
            />
        </g>
        <g filter="url(#filter3_d_5305_1573)">
            <path
                d="M103.207 75.634C103.94 74.1475 106.06 74.1475 106.793 75.634L111.882 85.9444C112.173 86.5347 112.736 86.9438 113.388 87.0385L124.766 88.6918C126.407 88.9302 127.062 90.9462 125.875 92.1032L117.641 100.129C117.17 100.588 116.955 101.25 117.066 101.899L119.01 113.231C119.29 114.865 117.575 116.111 116.108 115.34L105.931 109.989C105.348 109.683 104.652 109.683 104.069 109.989L93.8923 115.34C92.4251 116.111 90.7102 114.865 90.9904 113.231L92.934 101.899C93.0453 101.25 92.8302 100.588 92.3589 100.129L84.1255 92.1032C82.9385 90.9462 83.5935 88.9302 85.2339 88.6918L96.6122 87.0385C97.2636 86.9438 97.8267 86.5347 98.118 85.9444L103.207 75.634Z"
                fill="#F29441"
            />
            <path
                d="M103.879 75.9658C104.309 75.0948 105.5 75.0404 106.025 75.8027L106.121 75.9658L111.209 86.2764C111.584 87.0372 112.289 87.5789 113.113 87.751L113.28 87.7803L124.658 89.4336C125.619 89.5733 126.039 90.69 125.477 91.4248L125.351 91.5664L117.117 99.5918C116.51 100.184 116.213 101.021 116.304 101.858L116.327 102.025L118.271 113.358C118.434 114.316 117.503 115.06 116.63 114.752L116.457 114.676L106.279 109.325C105.528 108.931 104.64 108.906 103.872 109.251L103.721 109.325L93.543 114.676C92.6834 115.127 91.688 114.472 91.7109 113.547L91.7295 113.358L93.6729 102.025C93.8162 101.189 93.566 100.337 93 99.7129L92.8828 99.5918L84.6494 91.5664C83.9538 90.8884 84.2699 89.7383 85.1572 89.4746L85.3418 89.4336L96.7197 87.7803C97.5593 87.6583 98.2925 87.1567 98.7109 86.4258L98.791 86.2764L103.879 75.9658Z"
                stroke="#842F10"
                strokeWidth="1.5"
            />
        </g>
        <defs>
            <filter
                id="filter0_i_5305_1573"
                x="11.5"
                y="11.5"
                width="141"
                height="141"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="4" dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_5305_1573"
                />
            </filter>
            <filter
                id="filter1_d_5305_1573"
                x="28.5193"
                y="68.5191"
                width="54.9614"
                height="53.0547"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5305_1573"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5305_1573"
                    result="shape"
                />
            </filter>
            <filter
                id="filter2_d_5305_1573"
                x="53.5193"
                y="26.5191"
                width="54.9614"
                height="53.0547"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5305_1573"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5305_1573"
                    result="shape"
                />
            </filter>
            <filter
                id="filter3_d_5305_1573"
                x="78.5193"
                y="68.5191"
                width="54.9614"
                height="53.0547"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5305_1573"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5305_1573"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_5305_1573"
                x1="0"
                y1="0"
                x2="160"
                y2="164"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FFAB4D" />
                <stop offset="1" stopColor="#CC621A" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_5305_1573"
                x1="13"
                y1="13"
                x2="147"
                y2="147"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#D06615" />
                <stop offset="1" stopColor="#A04109" />
            </linearGradient>
        </defs>
    </svg>,
    "Achievement3Icon",
);

export default Achievement3Icon;
